import { render, staticRenderFns } from "./ExamsTable.vue?vue&type=template&id=ec411280&"
import script from "./ExamsTable.vue?vue&type=script&lang=js&"
export * from "./ExamsTable.vue?vue&type=script&lang=js&"
import style0 from "./ExamsTable.vue?vue&type=style&index=0&id=ec411280&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports